import { jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Select } from "../Select.js";
import { useActions } from "../hooks/useActions.js";
import { useFilterOptions } from "../hooks/useFilterOptions.js";
import { useOptions } from "../hooks/useOptions.js";
import { stateContext } from "./stateContext.js";
import { DEFAULT_VIRTUAL_LIST_BUFFER, defaultGetItemHeights } from "./utils.js";
function defaultGetOptionDisabled() {
  return false;
}
function SelectStateProvider(props) {
  const {
    value,
    items,
    testId,
    onChange,
    matchFilter,
    autocompleteProps,
    getOptionDisabled = defaultGetOptionDisabled
  } = props;
  const searchState = useState("");
  const [searchValue] = searchState;
  const getOptionLabel = props.getLabel;
  const buffer = props.listMode === "virtual" ? props?.buffer ?? DEFAULT_VIRTUAL_LIST_BUFFER : DEFAULT_VIRTUAL_LIST_BUFFER;
  const getItemHeights = props.listMode === "virtual" ? props?.getItemHeights ?? defaultGetItemHeights : defaultGetItemHeights;
  const customIsOptionToValue = autocompleteProps?.isOptionEqualToValue;
  const isOptionEqualToValue = useCallback(
    (a, b) => customIsOptionToValue ? customIsOptionToValue(a, b) : a === b,
    [customIsOptionToValue]
  );
  const { visibleOptions, selectedOption, selectableOptions, setVisibleOptions } = useOptions(
    items,
    value,
    getOptionDisabled,
    isOptionEqualToValue
  );
  const filterOptions = useFilterOptions(matchFilter);
  const actions = useActions(value, selectableOptions, onChange);
  const selectState = useMemo(
    () => ({
      props,
      state: { visibleOptions, selectedOption, selectableOptions },
      buffer,
      actions,
      searchState,
      filterOptions,
      getOptionLabel,
      getItemHeights,
      isOptionEqualToValue
    }),
    [
      props,
      buffer,
      actions,
      searchState,
      filterOptions,
      getOptionLabel,
      getItemHeights,
      visibleOptions,
      selectedOption,
      selectableOptions,
      isOptionEqualToValue
    ]
  );
  useEffect(() => {
    if (searchValue === "") {
      setVisibleOptions(items);
      return;
    }
    setVisibleOptions(
      filterOptions(items, {
        getOptionLabel,
        inputValue: searchValue
      })
    );
  }, [items, searchValue, filterOptions, getOptionLabel, setVisibleOptions]);
  return /* @__PURE__ */ jsx(stateContext.Provider, { value: selectState, children: /* @__PURE__ */ jsx(Select, { testId, selectState, setVisibleOptions }) });
}
export {
  SelectStateProvider
};
//# sourceMappingURL=SelectStateProvider.js.map
